import React, { PropsWithChildren } from 'react'
import { useScrolledContext } from 'src/hooks/use-isScrolled-context'
import { useMedia } from 'src/hooks/use-media'
import { useDispatchInfoContext } from 'src/hooks/use-is-disptach-info'

interface IProps extends PropsWithChildren<{}> {}

const LayoutPrimary: React.FC<IProps> = ({ children }) => {
  const { positionFromTop } = useScrolledContext()
  const isDesktop = useMedia('(min-width:1024px)')

  const { isDispatchInfoVisible } = useDispatchInfoContext()

  return (
    <div
      className={`container container-primary pt-8 ${
        isDispatchInfoVisible ? ' lg:pt-12' : ''
      }`}
      style={
        isDesktop
          ? isDispatchInfoVisible
            ? { paddingTop: `calc(${positionFromTop}px + 4.5rem)` }
            : { paddingTop: `calc(${positionFromTop}px + 2.5rem)` }
          : {}
      }
    >
      <div className="max-w-md sm:max-w-full m-auto">{children}</div>
    </div>
  )
}

export default LayoutPrimary
